import config from "@Config";
import type { GlobalState } from "@Context/common/general/initial-state.types";
import { AnalyticsEnvironments } from "@Enums";
import { AppName } from "@Runtime/runtime-enums";
import CryptoJS from "crypto-js";

let runtimePlatform: AppName | null = null;

export const setRuntimePlatform = (platform: AppName) => {
  runtimePlatform = platform;
};

export const getAnalyticsEnvironment = (state: GlobalState) => {
  if (state.device.isUnityEmbedded && state.device.isMobile) {
    return AnalyticsEnvironments.BYB_PRO;
  }

  if (state.device.isUnityEmbedded && state.device.isVR) {
    return AnalyticsEnvironments.VR;
  }

  if (runtimePlatform === AppName.Portal) {
    return AnalyticsEnvironments.WEB_PORTAL;
  }

  return AnalyticsEnvironments.NOT_FOUND;
};

export const hasVerifiedClientVersion = (clientVersion: string | null | undefined) =>
  Boolean(clientVersion) && clientVersion !== config.placeholderClientVersion;

/**
 * Hashes email using SHA-256 for analytics
 */
export const hashEmail = (email: string | null): string | null => {
  if (!email) return null;
  return CryptoJS.SHA256(email.toLowerCase().trim()).toString();
};